import { Box, Grid2 } from '@mui/material';
import ButtonComponent from 'components/ButtonComponent';
import ModalComponent from 'components/ModalComponent';
import TextFieldComponent from 'components/TextFieldComponent';
import { AppContext } from 'context/AppContextProvider';
import { useContext, useState } from 'react';
import { useCreatePartition } from 'services/AlarmCentralService/Virtual/hooks/useMutation';
import { IPartitionProps } from 'services/AlarmCentralService/Virtual/types';

interface VirtualAlarmCentralPartitionManagementModalProps {
  isOpen: boolean;
  onClose: () => void;
  virtualAlarmCentralId: number;
  partitions: IPartitionProps[];
}

const VirtualAlarmCentralPartitionManagementModal = ({
  isOpen,
  onClose,
  virtualAlarmCentralId,
  partitions,
}: VirtualAlarmCentralPartitionManagementModalProps) => {
  const [partition, setPartition] = useState<IPartitionProps>(
    {} as IPartitionProps,
  );
  const { showSnackbar } = useContext(AppContext);
  const { mutateAsync: mutateCreatePartitionAsync } = useCreatePartition();

  const onCreatePartition = () => {
    if (!partition.id) {
      for (let i = 0; i <= partitions.length; i++) {
        if (!partitions[i] || partitions[i].code != i) {
          partition.code = i;
        }
      }
      mutateCreatePartitionAsync(
        {
          partition,
          alarmCentralId: virtualAlarmCentralId,
        },
        {
          onSuccess: () => {
            showSnackbar('Partição criada com sucesso.', 'success');
            onClose();
          },
        },
      );
    }
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      title="Edição de partição"
      onClose={() => {
        onClose();
        setPartition({} as IPartitionProps);
      }}
    >
      <Grid2 container columnSpacing={2}>
        <Grid2 size={{ md: 6, xs: 12 }}>
          <TextFieldComponent
            label="Nome"
            value={partition.name}
            onChangeText={(name) =>
              setPartition((oldStt) => ({ ...oldStt, name }))
            }
          />
        </Grid2>
        <Grid2 size={{ md: 6, xs: 12 }}>
          <TextFieldComponent
            label="Conta"
            value={partition.account}
            onChangeText={(account) =>
              setPartition((oldStt) => ({ ...oldStt, account }))
            }
          />
        </Grid2>
      </Grid2>

      <Box sx={{ display: 'flex', justifyContent: 'end' }}>
        <ButtonComponent sx={{ mr: 2 }} onClick={onCreatePartition}>
          Criar
        </ButtonComponent>
        <ButtonComponent
          color="error"
          onClick={() => {
            onClose();
            setPartition({} as IPartitionProps);
          }}
        >
          Cancelar
        </ButtonComponent>
      </Box>
    </ModalComponent>
  );
};

export default VirtualAlarmCentralPartitionManagementModal;
